<template>
  <div>

   <nav-bar></nav-bar>

     <div style="position: absolute;bottom: 0;top: 0;background-repeat: no-repeat;background-size: cover;z-index: -100" :style="{backgroundImage:'url('+require('../assets/bg.png')+')'}">
    <div class="container">

      <p class="tip"><span>为确保善款安全，操作前请与贵州省扶贫基金会联系</span></p>

        <div class="panel">


            <div style="border-left: 3px solid red"><p style="margin-top: 0;font-size: 14px;margin-left: 5px">信息</p></div>

            <van-row>
                <van-col span="8">
                    <img style="width: 100px;height: 80px" :src="url"/>
                </van-col>
                <van-col span="15" offset="1">
                    <p style="font-weight: bold;margin-top: 0;font-size: 14px">{{title}}</p>
                    <p style="font-size: 14px;margin: 0">数量:{{num}}</p>
                    <p style="font-size: 14px;margin: 0;color: red" >总计：¥{{total}}</p>

                </van-col>

            </van-row>
            <p style="margin-top: 0;margin-bottom:0"><span>亲爱的善行家：</span></p>
            <p style="margin-top: 5px;margin-bottom: 0">&nbsp;&nbsp; &nbsp;&nbsp; 我们在接收到您义捐的善款后，在5个工作日内将票据和爱心荣誉匾牌通过邮寄的方式给您。感谢您的支持！</p>
        </div>
        <div class="panel" style="margin-top: 5px">
            <div style="border-left: 3px solid red"><p style="margin-top: 0;font-size: 14px;margin-left: 5px">基金会信息</p></div>

            <div style="color: #999;font-size: 15px">账户名称
                <br>
                <span style="color: #333">贵州省扶贫基金会</span>

            </div>
            <div style="color: #999;font-size: 15px;margin-top: 10px">开户行
                <br>
                <span style="color: #333">贵州乌当农村商业银行股份有限公司野鸭支行</span>

            </div>

            <div style="color: #999;font-size: 15px;margin-top: 10px">账号
                <br>
                <span style="color: #333">820000000002283995</span>

            </div>

             <div style="width: 100%;height: 1px;background-color: #f2f2f2;margin-top: 10px"></div>

            <div style="color: #999;font-size: 15px;margin-top: 10px">联系电话
                <br>
                <span style="color: #333">0851-85287193</span>

            </div>
            <div style="color: #999;font-size: 15px;margin-top: 10px">邮编
                <br>
                <span style="color: #333">550000</span>

            </div>

   </div>
    </div>
      </div>

  </div>
</template>

<script>


    import NavBar from '@/components/NavBar'

    export default {
        name: 'about',
        components: {

            NavBar
        },

        data(){

            return{

                title:'',
                num:0,
                total:0,
                url:'',

            }
        },

        created(){

            this.title = this.$route.query.title;
            this.num = this.$route.query.num;
            this.total = this.$route.query.total;
            this.url = this.$route.query.url;

        }
    }


</script>

<style>

 

  .container{
    padding:50px 10px 10px 10px;


  }
  .tip{
    margin-top:10px;
    background: inherit;
    background-color: rgba(255, 0, 0, 0.0980392156862745);
    border: none;
    font-weight: 400;
    padding: 5px;
    font-style: normal;
    font-size: 14px;
    color: #DA2D32;
    border-radius: 2px;

  }

    .panel{

        padding: 10px;
        background-color: white;
        border-radius: 2px;
    }

    .panel p{

        font-size: 12px;
        color: #333333;
    }
    .panel span{

        font-size: 14px;
    }

</style>